// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"b8-z"};